/* tslint:disable */
/* eslint-disable */
/* @relayHash 4f78342cdb8ac3e75a43d8f6073727b4 */

import { ConcreteRequest } from "relay-runtime";
export type UploadProfilePictureMutationVariables = {
    fileType: string;
    contentLength: number;
};
export type UploadProfilePictureMutationResponse = {
    readonly profileImageUploadRequest: {
        readonly successToken: string;
        readonly url: string;
    } | null;
};
export type UploadProfilePictureMutation = {
    readonly response: UploadProfilePictureMutationResponse;
    readonly variables: UploadProfilePictureMutationVariables;
};



/*
mutation UploadProfilePictureMutation(
  $fileType: String!
  $contentLength: Int!
) {
  profileImageUploadRequest(input: {fileType: $fileType, contentLength: $contentLength}) {
    successToken
    url
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "fileType",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "contentLength",
            "type": "Int!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "profileImageUploadRequest",
            "storageKey": null,
            "args": [
                {
                    "kind": "ObjectValue",
                    "name": "input",
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentLength",
                            "variableName": "contentLength"
                        },
                        {
                            "kind": "Variable",
                            "name": "fileType",
                            "variableName": "fileType"
                        }
                    ]
                }
            ],
            "concreteType": "UploadFileResp",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "successToken",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "url",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "UploadProfilePictureMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "UploadProfilePictureMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "UploadProfilePictureMutation",
            "id": null,
            "text": "mutation UploadProfilePictureMutation(\n  $fileType: String!\n  $contentLength: Int!\n) {\n  profileImageUploadRequest(input: {fileType: $fileType, contentLength: $contentLength}) {\n    successToken\n    url\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '8c0d053937bdfe5d5c082d1d8e278c40';
export default node;
